<template>
  <div class="base-checkbox" @click.stop="stopDeepClick()">
    <div class="rel">
      <v-sheet :width="size" :height="size" color="transparent">
        <IconsBaseCheckbox
          :icon="indeterminate
            ? 'minus'
            : check === trueValue
            ? outlined
              ? 'check-outlined'
              : 'check'
            : 'blank'"
          :color="invisible ? 'transparent' : disabled ? '#e0e0e0' : color"
        />
      </v-sheet>
      <v-checkbox
        v-model="check"
        @change="changeCheck"
        hide-details
        dense
        :disabled="disabled"
        ref="check"
        class="abs"
      />
    </div>
    <slot>
      {{ text }}
    </slot>
  </div>
</template>

<script>
import IconsBaseCheckbox from "../icons/base/IconsBaseCheckbox";
export default {
  name: 'BaseCheckbox',
  components: {IconsBaseCheckbox},
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array, Date],
      default: true,
    },
    trueValue: {
      type: [Boolean, Number, String, Object, Array, Date],
      default: true,
    },
    falseValue: {
      type: [Boolean, Number, String, Object, Array, Date],
      default: false,
    },
    size: {
      type: [Number, String],
      default: 20,
    },
    color: {
      type: String,
      default: '#277FAF',
    },
    outlined: Boolean,
    text: String,
    disabled: Boolean,
    invisible: Boolean
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },
    indeterminate() {
      return this.value !== this.trueValue && this.value !== this.falseValue
    },
  },
  watch: {
    indeterminate() {
      this.$emit('change', this.indeterminate)
    },
  },
  data: () => ({
    check: true,
  }),
  created() {
    this.check = this.value
  },
  methods: {
    changeCheck() {
      this.$emit('input', this.check)
    },
    clickCheck() {
      this.$refs.check.onclick
    },
    stopDeepClick() {
      //to do nothing, just stop the click event's propagation
    }
  },
}
</script>

<style scoped lang="scss">
.base-checkbox {
  display: flex;
  column-gap: 10px;
  align-items: center;
  cursor: pointer;
}
.rel {
  position: relative;
  width: max-content;
}

.abs {
  position: absolute;
  top: -9px;
  left: -2px;
  opacity: 0.01;
}

.v-input--selection-controls__ripple:deep() {
  margin: 0 !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
}

.v-input__slot:not(.v-textarea):deep()  {
  min-height: 20px !important;
}

//.v-input--selection-controls.v-input--dense .v-input--selection-controls__ripple
</style>
